import * as Actions from "../Actions/ScreenLockActions";

const initialState = {
    open: false,
    disabled: false,
};

const ScreenLockReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.OPEN_DIALOG:
            {
                return {
                    ...state,
                    open: action.open,
                    disabled: false,
                };
            }
        case Actions.DISABLED_LOCK:
            {
                return {
                    ...state,
                    disabled: action.disabled,
                    open: false,
                };
            }
        default:
            {
                return state;
            }
    }
};

export default ScreenLockReducer;
